import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class OnSideFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.OnSide;
    }

    getRawFragment() {
        const rawPlay = "ONSIDE:";
        return rawPlay;
    }
}
